import { FC } from 'react';
import { CRM_REDIRECT_LINK } from '~/config';
import useAuth from '~/hooks/useAuth';
import useLocales from '~/hooks/useLocales';
import { NavItemRoot } from './nav-section/vertical/NavItem';
import SvgIconStyle from './SvgIconStyle';

type Props = {
  isCollapse: boolean;
};

const CrmRedirectButton: FC<Props> = ({ isCollapse }) => {
  const { t } = useLocales();
  const { user } = useAuth();
  const url = `${CRM_REDIRECT_LINK}/${user?.attributes.company_id}/${user?.attributes.uid}`;

  const item = {
    title: t('navbar.crm'),
    path: url,
    icon: <SvgIconStyle src={`/icons/ic_launch.svg`} sx={{ width: 1, height: 1 }} />,
  };

  return <NavItemRoot item={item} isCollapse={isCollapse} sx={{ justifyContent: 'flex-start' }} />;
};

export default CrmRedirectButton;
